import React, { useState } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { useTranslation } from '../../contexts/TranslationContext';
import LoginMarketingPanel from './LoginMarketingPanel';
import './login-auth.css';

const AuthLanguageSelector = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="auth-login__lang">
      <button
        type="button"
        className="auth-login__lang-btn"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <Globe aria-hidden="true" />
        <span>{currentLanguage}</span>
        <ChevronDown
          aria-hidden="true"
          style={{ transform: open ? 'rotate(180deg)' : undefined, transition: 'transform 0.15s' }}
        />
      </button>

      {open ? (
        <div className="auth-login__lang-menu" role="listbox">
          {availableLanguages.map((lang) => (
            <button
              key={lang}
              type="button"
              role="option"
              aria-selected={currentLanguage === lang}
              className={currentLanguage === lang ? 'is-active' : undefined}
              onClick={() => {
                changeLanguage(lang);
                setOpen(false);
              }}
            >
              {lang}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const AuthPageLayout = ({ children, scrollable = false }) => {
  return (
    <div className="auth-login">
      <div className="auth-login__shell">
        <LoginMarketingPanel />

        <div className="auth-login__main">
          <div className="auth-login__topbar auth-login__topbar--mobile">
            <a href="/" className="auth-login__mobile-logo" aria-label="ABET Partners">
              <img src="/images/logo-Black.png" alt="ABET Partners" />
            </a>
            <AuthLanguageSelector />
          </div>

          <div className="auth-login__topbar--desktop">
            <AuthLanguageSelector />
          </div>

          <div
            className="auth-login__body"
            style={
              scrollable
                ? { justifyContent: 'flex-start', overflowY: 'auto', paddingTop: '1.5rem' }
                : undefined
            }
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPageLayout;
